<template>
  <div :class="{'cars-preview': true, 'bikes-preview': isBikeOnly }" v-if="cars">
    <div class="row">
      <div class="columns">

        <div class="row text-center">
          <div class="columns small-24 medium-22 medium-offset-1">


            <admin-edit title="Team bearbeiten`" :url="`/pl/0/platform_admin/teams/${teamsiteConfig.id}`"></admin-edit>
            <h4>{{ $t(`teamsite.${vehicleString('cars', 'bikes')}.subtitle`) }}</h4>
            <h3>{{ $t(`teamsite.${vehicleString('cars', 'bikes')}.title`) }}</h3>

            <div class="white-box">

              <div class="row">
                <car-preview :class="carPreviewCss" v-for="car in cars" :car="car" :key="car.id"/>
              </div>

              <div class="row">
                <div class="columns small-22 small-offset-1 medium-16 medium-offset-4 large-10 large-offset-7 text-center">
                  <br>
                  <mq-link destination="/cars" :color="teamsiteConfig.color" type="button" size="small">
                    {{ $t(`teamsite.${vehicleString('cars', 'bikes')}.tariff_detail_link${isFreeForAll ? '_free' : ''}`) }}
                  </mq-link>
                  <br>
                </div>
              </div>

            </div>


          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CarsPreview',

    props: {
      cars: {
        type: Array,
        required: false
      }
    },

    computed: {
      carPreviewCss () {
        return `columns medium-${24 / this.cars.length}`
      }
    }
  }
</script>

<style lang="scss" scoped>
h4 {
  color: $color-white;
  margin-top: 40px;
  margin-bottom: 10px;
}

h3 {
  color: $color-white;
}

.cars-preview {
  background-color: #ececec;
  color: $color-white;
  background-size: cover;
  background-position: center center;
  background-image: url('../assets/cars-bg.jpg');
}

.bikes-preview {
  background-image: url('../assets/bikes-bg.jpg');
}

.moqo_link {
  max-width: 999px;
  color: $white;
}

.white-box {
  background-color: $color-white;
  color: black;
  margin-bottom: 60px;
  margin-top: 60px;
  position: relative;
  $shadow-height: 10px;
  &:after {
    content: ' ';
    position: absolute;
    background-color: #D6D6D6;
    bottom: -$shadow-height;
    left: $shadow-height;
    right: $shadow-height;
    height: $shadow-height
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CarsPreview.vue